import { useState, useEffect } from 'react';
import { Settings } from 'lucide-react';
import Stepper from './Stepper';
import OrganizationForm from './OrganizationForm';
import HoldingSetup from './HoldingSetup';
import OrgStructure from './OrgStructure';
import Branding from './Branding';
import ModuleActivation from './ModuleActivation';
import GroupDashboardConfig from './GroupDashboardConfig';
import ExecutiveDashboardConfig from './ExecutiveDashboardConfig';
import PortalActivation from './PortalActivation';
import RoleSetup from './RoleSetup';
import UserSetup from './UserSetup';
import UserHierarchy from './UserHierarchy';
import GovernanceSubmodules from './GovernanceSubmodules';
import DashboardWidgets from './DashboardWidgets';
import CompanyProfileSetup from './CompanyProfileSetup';
import './styles/PlatformConfiguration.css';

const PlatformConfiguration = () => {
  const [currentStep, setCurrentStep] = useState(1);

  const [organizationId, setOrganizationId] = useState<string>(() => localStorage.getItem('organizationId') || '');

  useEffect(() => {
    if (organizationId) {
      localStorage.setItem('organizationId', organizationId);
    }
  }, [organizationId]);

  const nextStep = () => {
    setCurrentStep((prev) => Math.min(prev + 1, 18));
  };

  const previousStep = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 1));
  };

  return (
    <div className="platform-page">
      <div className="platform-container">
        <div className="platform-header">
          <div className="platform-icon-box">
            <Settings className="platform-icon" />
          </div>

          <h1 className="platform-title">Platform Configuration</h1>

          <p className="platform-subtitle">Configure your governance, risk, and compliance platform</p>
        </div>

        <div className="platform-stepper">
          <Stepper currentStep={currentStep} />
        </div>

        <div className="px-5 mt-8">
          <div className="px-14 mt-8">
            {currentStep === 1 && (
              <OrganizationForm nextStep={nextStep} previousStep={previousStep} onCreated={(id: string) => setOrganizationId(id)} />
            )}

            {currentStep === 2 && <HoldingSetup nextStep={nextStep} previousStep={previousStep} />}

            {currentStep === 3 && <OrgStructure nextStep={nextStep} previousStep={previousStep} />}

            {currentStep === 4 && <Branding nextStep={nextStep} previousStep={previousStep} organizationId={organizationId} />}

            {currentStep === 5 && <ModuleActivation nextStep={nextStep} previousStep={previousStep} organizationId={organizationId} />}

            {currentStep === 6 && <GroupDashboardConfig nextStep={nextStep} previousStep={previousStep} />}

            {currentStep === 7 && <ExecutiveDashboardConfig nextStep={nextStep} previousStep={previousStep} />}

            {currentStep === 8 && <PortalActivation nextStep={nextStep} previousStep={previousStep} />}

            {currentStep === 9 && <RoleSetup nextStep={nextStep} previousStep={previousStep} />}

            {currentStep === 10 && <UserSetup nextStep={nextStep} previousStep={previousStep} />}

            {currentStep === 11 && <UserHierarchy nextStep={nextStep} previousStep={previousStep} />}

            {currentStep === 12 && <GovernanceSubmodules nextStep={nextStep} previousStep={previousStep} />}

            {currentStep === 13 && <DashboardWidgets nextStep={nextStep} previousStep={previousStep} />}

            {currentStep === 14 && <CompanyProfileSetup nextStep={nextStep} previousStep={previousStep} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformConfiguration;
